// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"3f7cc694","703":"733a4e05"}[chunkId] + ".chunk.js";
};